<template>
  <div id="rightMainContainer" style="width:100%">
    <operations @pf="parent" @pf4="parent4"></operations>
    <div style="height:var(--middle-space);background:#f4f5fa"></div>
    <navAndSearch></navAndSearch>
    <fileTable ref="goodslist"></fileTable>
  </div>
</template>

<script>
import navAndSearch from "./nav/nav";
import fileTable from "./fileTable/fileTable";
import operations from "./operations/operations";
import { mapState } from "vuex";
export default {
  name: "Publicinformation",
  components: {
    navAndSearch,
    fileTable,
    operations
  },
  data() {
    return {
      argument: {
        folderId: "EnterprisePublic",
        enterpriseId: ""
      }
    };
  },
  computed: {
    ...mapState({
      currentNode: (state) => state.perFile.currentTreeNodeFen,
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  // 离开路由之前执行的函数
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("perFileUpdateNavFen", []);
    next();
  },
  created() {
    this.argument.enterpriseId = this.enterpriseId;
  },
  methods: {
    parent() {
      this.argument.folderId = this.currentNode.folderId;
      this.$refs.goodslist.querlist2(this.argument);
    },
    parent4(data) {
      if (data) {
        this.$refs.goodslist.querlist4(data);
      } else {
        this.argument.folderId = this.currentNode.folderId;
        this.$refs.goodslist.querlist2(this.argument);
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#rightMainContainer {
  height: 100%;
  background-color: #fff;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  flex-direction: column;
}
::v-deep span{
  font-size: 14px !important;
}
::v-deep .cell{
  font-size: 14px !important;
}
</style>
